import React from 'react';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';

import { EvoachLogo } from '../EvoachLogo';
import { theme } from '../../theme/theme';
import { BaseComponent } from '../Component';

import { HeaderMenu } from './HeaderMenu';

const PREFIX = 'AppHeader';

const classes = {
  root: `${PREFIX}-root`,
  menuButton: `${PREFIX}-menuButton`,
  separator: `${PREFIX}-separator`,
};

export interface AppHeaderComponent extends BaseComponent {
  type: 'appHeader';
  props: AppHeaderProps;
}
export interface AppHeaderProps {
  appheadertitle: string;
  handleLoginLogout: Function;
  loginLogoutLabel: string;
  additionalMenuItems?: JSX.Element[];
  avatarName: string;
  avatarEmail?: string;
  avatarSrc?: string;
  showLogo?: boolean;
  showMenu?: boolean; // for PROD-1246
  homeRoute?: string;
}

export const AppHeader: React.FC<AppHeaderProps> = ({
  appheadertitle,
  handleLoginLogout,
  loginLogoutLabel,
  additionalMenuItems,
  avatarName,
  avatarEmail,
  avatarSrc,
  showLogo = false,
  showMenu = true,
  homeRoute,
}) => {
  const getHomeLink = () => {
    return (
      <>
        {!showLogo ? (
          <Typography
            variant="body1"
            color="secondary.contrastText"
            noWrap
            component="span"
          >
            evoach
          </Typography>
        ) : (
          <div
            style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '50%',
              padding: 3,
            }}
          >
            <EvoachLogo width={50} />
          </div>
        )}
      </>
    );
  };

  return (
    <AppBar
      position="static"
      className={classes.root}
      sx={{
        flexGrow: 1,
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        fontFamily: 'Roboto',
        fontWeight: 700,
        height: '60px',
      }}
    >
      <Toolbar>
        {homeRoute !== undefined ? (
          <Link to={homeRoute} style={{ textDecoration: 'none' }}>
            {getHomeLink()}
          </Link>
        ) : (
          <>{getHomeLink()}</> // display in Storybook without React Router
        )}
        <Box sx={{ flexGrow: 1 }} />
        <Typography
          variant="body1"
          component="span"
          color="secondary.contrastText"
        >
          {appheadertitle}
        </Typography>
        <Box sx={{ flexGrow: 1 }} />
        {showMenu && (
          <HeaderMenu
            handleLoginLogout={handleLoginLogout}
            loginLogoutLabel={loginLogoutLabel}
            menuItems={additionalMenuItems}
            avatarName={avatarName}
            avatarEmail={!avatarSrc ? avatarEmail : ''}
            avatarSrc={avatarSrc}
          />
        )}
      </Toolbar>
    </AppBar>
  );
};
